import { render } from "./DailyRecord.vue?vue&type=template&id=3683ad4a&scoped=true"
import script from "./DailyRecord.vue?vue&type=script&lang=js"
export * from "./DailyRecord.vue?vue&type=script&lang=js"

import "./DailyRecord.vue?vue&type=style&index=0&id=3683ad4a&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3683ad4a"]])

export default __exports__